<template>
  <b-modal
    id="edit-notes"
    ref="edit-notes"
    size="sm-size"
    modal-class="notes-modal"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('edit_notes') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <textarea
        v-model="note.text"
        name="notes"
        class="manual-entry-notes"
        :placeholder="label.get('type_your_notes_here')"
      />
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="atto-btn submit"
        :disabled="disableSubmitButton"
        @click="saveNoteChanges"
      >
        {{ label.get('add_notes') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
    import TimesheetService from '../TimesheetService';
    export default {
        name: "EditNotesComponent",
        props: {
          note: {
            type: Object,
            default: () => {
              return {};
            }
          }
        },
        data() {
          return {
            disableSubmitButton: false
          };
        },
        mounted() {
            this.$refs['edit-notes'].show();
        },
        methods: {
            close() {
                this.$emit('onClose');
            },
            saveNoteChanges() {
                this.disableSubmitButton = true;
                TimesheetService.updateNote(this.note.timesheet_id, this.note).then(response => {
                    this.$emit('onClose', this.note);
                    this.$awn.success(response.data.message);
                }).catch((error) => {
                    console.log(error);
                    this.disableSubmitButton = false;
                });
            }
        }
    }
</script>

<style lang="scss">
    .notes-modal {
      .modal-head{
        padding: 24px !important;
        background-color: #FAFAFA;
        border-bottom: 1px solid #EFEFEF;
        height: 72px;

        .modal-title{
          font-size: 1rem;
          &:before{
            content: "\E96E";
            font-family: attotime;
            width: 18px;
            height: 18px;
            font-size: 1rem;
            color: #C7C7C7;
            margin-right: 10px;
            position: relative;
            top: 1px;
          }
        }
      }
        .modal-sm-size {
            .modal-footer {
                flex-direction: row;
                padding: 8px 56px 56px;
                .atto-btn{
                  width: 100%;
                }
            }

            .content-wrapper {
              padding: 24px 56px 56px !important;
                textarea {
                    padding: 0;
                    width: 100%;
                    min-height: 160px;
                    font-family: $roboto-font;
                    font-weight: $roboto-regular;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    resize: none;
                    border: none;
                    overflow-y: hidden;
                    color: #666666;
                    @include style-placeholder($atto-not-active);

                  &:focus{
                    border: none;
                    outline: none;
                  }
                }
            }
        }
    }
</style>